import React, { useMemo, useRef, useState, useEffect } from "react";
import useTranslation from "../../i18n/useTranslation";

const LANGUAGES = [
    { code: "en", short: "EN", label: "English", flag: "🇬🇧" },
    { code: "es", short: "ES", label: "Español", flag: "🇪🇸" },
    { code: "fr", short: "FR", label: "Français", flag: "🇫🇷" },
];

const LanguageSelector = ({ variant = "desktop" }) => {
    const { language, setLanguage, t } = useTranslation();
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    const activeLang = useMemo(() => {
        return LANGUAGES.find((l) => language?.startsWith(l.code)) || LANGUAGES[0];
    }, [language]);

    const changeLang = (code) => {
        setLanguage(code);
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (variant === "mobile") {
        return (
            <div className="nav-mobile-lang">
                <span className="nav-mobile-lang-label">
                    {t("common.language", "Language")}
                </span>

                <div className="nav-mobile-lang-options">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang.code}
                            type="button"
                            className={
                                "lang-chip" +
                                (language?.startsWith(lang.code) ? " is-active" : "")
                            }
                            onClick={() => changeLang(lang.code)}
                        >
                            <span className="lang-flag lang-flag-small">{lang.flag}</span>
                            <span>{lang.short}</span>
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="lang-dropdown" ref={wrapperRef}>
            <button
                type="button"
                className="lang-current"
                onClick={() => setOpen((v) => !v)}
                aria-label={t("common.language", "Change language")}
            >
                <span className="lang-globe">🌐</span>
                <span className="lang-flag">{activeLang.flag}</span>
                <span className="lang-code">{activeLang.short}</span>
                <span className="lang-caret">▾</span>
            </button>

            {open && (
                <div className="lang-menu">
                    {LANGUAGES.map((lang) => {
                        const isActive = language?.startsWith(lang.code);

                        return (
                            <button
                                key={lang.code}
                                type="button"
                                className={"lang-option" + (isActive ? " is-active" : "")}
                                onClick={() => changeLang(lang.code)}
                            >
                                <span className="lang-flag">{lang.flag}</span>
                                <span className="lang-option-code">{lang.short}</span>
                                <span className="lang-option-label">{lang.label}</span>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;